import { LockSimpleIcon, UsersThreeIcon } from '@phosphor-icons/react'

export const viewVisibilities = {
  private: 'private',
  shared: 'shared',
}

export const visibilityOptions = [
  {
    value: viewVisibilities.private,
    label: 'Privada',
    description: 'Solo tú puedes verla o usarla.',
    Icon: LockSimpleIcon,
  },
  {
    value: viewVisibilities.shared,
    label: 'Compartida',
    description: 'Hace la vista visible para otros usuarios.',
    Icon: UsersThreeIcon,
  },
]

export const maxVisibleSharedGroups = 3
